import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import React from 'react';
import { parseIcon } from './menuOptions';

export function VerticalMenuItem({ favourMobileIcon = false, ...menuItem }) {
  const content = (
    <>
      {parseIcon(
        (favourMobileIcon ? menuItem.mobileIcon : undefined) || menuItem.icon
      )}
      {menuItem.title}
    </>
  );

  return (
    <Menu.Item>
      {menuItem.href ? (
        <a
          className='gSemiBold row-center'
          href={menuItem.href}
          onClick={menuItem.onClick}
        >
          {content}
        </a>
      ) : (
        <Link
          className='gSemiBold row-center'
          to={menuItem.link || '#'}
          onClick={menuItem.onClick}
        >
          {content}
        </Link>
      )}
    </Menu.Item>
  );
}
